import React from "react";
import { wrapIrSlots } from "../components/ads/irSlots";
import { splitNewsContent } from "../utils/adChunks";

// Места в тексте шаблон отдавал adfox; без него в бандле они пустые, блок на них
// заводится только кампанией в БД.
const IR_PLACES = { 1: null, 2: null, 3: null, 4: null, 5: null };

function NewsText({ news, isFull, isDesktop, dbMode = false }) {
    const contentRef = React.useRef(null);
    const url = new URL(window.location.href);
    const chunks = splitNewsContent(news);
    const adfoxNum = chunks.filter((c) => c === "ADFOX").length;
    // Тизерных мест в этом шаблоне нет: в режиме БД json-запись ir-места не рисует ничего.
    const selectedComponentsMap = wrapIrSlots(IR_PLACES, {
        isFull,
        isDesktop,
        json: dbMode ? null : undefined,
    });
    let cnt = 1;

    const fullNewsUrl = new URL(url);
    if (fullNewsUrl.pathname.includes("preview/")) {
        fullNewsUrl.pathname = fullNewsUrl.pathname.replace(/\/(preview|news|preview\/news)\//, "full/");
    } else {
        fullNewsUrl.searchParams.set("view", "full");
    }

    return (
        <div className="newsDetail">
            <div className={!isFull ? "news-content-inner__toggle" : null} ref={contentRef}>
                {chunks.map((chunk, i) => {
                    if (chunk === "ADFOX" && cnt <= adfoxNum && isFull) {
                        cnt += 1;
                        return <React.Fragment key={`ad-${cnt - 1}`}>{selectedComponentsMap[cnt - 1]}</React.Fragment>;
                    }
                    if (i === chunks.length - 1) {
                        cnt = 1;
                    }
                    return (
                        <React.Fragment key={i}>
                            <p hidden={!isFull && chunk === "ADFOX"} dangerouslySetInnerHTML={{ __html: chunk }} />
                        </React.Fragment>
                    );
                })}
            </div>
            <div className={!isFull ? "toggleNews" : "hidden"}>
                <div className={!isFull ? "fadeNews" : null}></div>
                <a className={!isFull ? "openButton" : "hidden"} href={fullNewsUrl.toString()} target="_blank">
                    Показать больше
                </a>
            </div>
        </div>
    );
}

NewsText.defaultProps = {
    teasers: [],
};

export default NewsText;
